(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('.joinconv-linkbutton').click(function () {
      $('.anonymous-comment-form').show();
      $('.comment-post').show();
      // $(".comments-list-content").show();
      return false;
    });
  });
})(jQuery);